"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module Services.Security
 */
/**
 * Server response from GET_GLOBAL_PERMISSION_SERVICE request
 */
var ListPathPermissionsResult = /** @class */ (function () {
    /**
     * Create a new ListGlobalPermissionsResult instance.
     * @param permissions the set of global permissions
     */
    function ListPathPermissionsResult(permissions) {
        this.permissions = permissions;
    }
    return ListPathPermissionsResult;
}());
exports.ListPathPermissionsResult = ListPathPermissionsResult;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/security/list-path-permissions-result.js
// module id = 1302
// module chunks = 1